<div class="vault-overlay" *ngIf="visible">
    <div class="vault-shell">
        <!-- Hamburger for mobile -->
        <button class="vault-hamburger" (click)="toggleMenu()" aria-label="Toggle menu">
            <span></span><span></span><span></span>
        </button>

        <!-- LEFT MENU -->
        <aside class="vault-menu" [class.menu-open]="menuOpen">
            <h3>Vault</h3>
            <button [class.active]="activeView === 'receive'" (click)="select('receive')">
                Receive Cash
            </button>
            <button [class.active]="activeView === 'pay'" (click)="select('pay')">
                Pay Cash
            </button>
            <button [class.active]="activeView === 'ledger'" (click)="select('ledger')">
                Ledger
            </button>
            <div class="spacer"></div>
            <button class="close" (click)="close()">Exit Vault</button>
        </aside>

        <!-- RIGHT CONTENT -->
        <section class="vault-content" [class.menu-open]="menuOpen">
            <app-vault-receive *ngIf="activeView === 'receive'"></app-vault-receive>
            <app-vault-pay *ngIf="activeView === 'pay'"></app-vault-pay>
            <app-vault-ledger-view *ngIf="activeView === 'ledger'"></app-vault-ledger-view>
        </section>
    </div>
</div>